"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.waiverAcceptance = void 0;
const waiver_1 = require("./waiver");
exports.waiverAcceptance = {
    id: '21111111-2111-2111-2111-211111111111',
    waiver_id: waiver_1.waiver.id
};
